import React from "react"
import { FormattedMessage } from "gatsby-plugin-intl"

import {
  StyledBlogJoiningContainer,
  StyledBlogTitle,
  StyledBlogContent,
  StyledBlogButton,
  StyledJoiningTitle,
  StyledJoiningContent,
  StyledJoiningButton,
} from "./index.styles"
import personalFundraiseImage3 from "../../../assets/images/personalfundraise-3.png"
import personalFundraiseImage4 from "../../../assets/images/personalfundraise-4.png"
import personalFundraiseImage5 from "../../../assets/images/personalfundraise-5.png"

const HowToPersonalFundraiseSection = () => {
  return (
    <>
      <StyledBlogTitle className="mh-3">
        <FormattedMessage
          id="aboutUs::howToPersonalFundraise::title"
          defaultMessage="How to start your fundraiser campaign?"
        />
      </StyledBlogTitle>
      <StyledBlogJoiningContainer className="blog-joining-wrapper">
        <StyledBlogTitle>
          1
        </StyledBlogTitle>
        <StyledBlogContent>
          <FormattedMessage
            id="aboutUs::howToPersonalFundraise::content"
            defaultMessage="Choose your cause, name the campaign, set a start and finish dates"
          />
        </StyledBlogContent>
        <img
          src={personalFundraiseImage3}
          alt="Personal Fundraise"
        />

        <StyledBlogTitle>
          2
        </StyledBlogTitle>
        <StyledJoiningContent>
          <FormattedMessage
            id="aboutUs::howToPersonalFundraise::content2"
            defaultMessage="Explain why it is important in up to 3 languages for a worldwide recognition"
          />
        </StyledJoiningContent>
        <img
          src={personalFundraiseImage4}
          alt="Personal Fundraise"
        />
        <StyledBlogTitle>
          3
        </StyledBlogTitle>
        <StyledJoiningContent>
          <FormattedMessage
            id="aboutUs::howToPersonalFundraise::content3"
            defaultMessage="Once launched, your campaign will be published alongside others—share it to spread the word and boost its impact"
          />
        </StyledJoiningContent>
        <img
          src={personalFundraiseImage5}
          alt="Personal Fundraise"
        />

      </StyledBlogJoiningContainer>
    </>
  )
}

export default HowToPersonalFundraiseSection
